import { render } from "./RestauraceSekceJidloInput.vue?vue&type=template&id=c59a2182"
import script from "./RestauraceSekceJidloInput.vue?vue&type=script&lang=js"
export * from "./RestauraceSekceJidloInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__